<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="显隐列"
        placement="top"
        v-if="columns"
      >
        <div @click="showColumn()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12xsl.png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">显隐列</span>
        </div>
      </el-tooltip>
    </div>
    <!-- 检索 -->
    <div
      class="width100 f14 backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        size="small"
        label-width="100px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="注册号">
          <el-input
            placeholder="请输入商标注册号"
            v-model="ruleForm.number"
          ></el-input>
        </el-form-item>
        <el-form-item label="商标名称">
          <el-input
            v-model="ruleForm.crux"
            placeholder="支持商标名称及摘要模糊检索
"
          ></el-input>
        </el-form-item>
        <div class="margin-left20 margin-top10 margin-bot10">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()">重 置</el-button>
        </div>
      </el-form>
      <span
        class="attention margin-top10 margin-bot10 margin-left20 margin-right20"
        @click="patenttrusteeship()"
        >同步商标</span
      >
    </div>

    <el-skeleton
      class="width100 backwhite border-rd3"
      :loading="loading"
      animated
      :throttle="500"
    >
      <template slot="template">
        <div
          class="
            width100
            backwhite
            pad-bot20 pad-top20
            margin-auto margin-top15
            border-rd3
            alldigital
          "
          v-if="total != 0"
        >
          <el-table
            :data="pages"
            stripe
            style="width: 98%"
            class="eltable margin-auto f14"
          >
            <el-table-column label="商标名称" v-if="columns[0].visible">
              <template slot-scope="scope">
                <span
                  class="f14 cursorpointer bluecolor text-ellipsis"
                  @click="todetails(scope.row)"
                >
                  {{ scope.row.TrademarkName }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="InternationalClass"
              label="国际分类"
              v-if="columns[1].visible"
            >
            </el-table-column>
            <el-table-column
              prop="RegNumber"
              label="商标号码"
              v-if="columns[2].visible"
            >
            </el-table-column>
            <el-table-column
              prop="ApplyDate"
              label="申请日期"
              v-if="columns[3].visible"
            >
            </el-table-column>
            <el-table-column
              prop="SpecialEndDate"
              label="到期日期"
              v-if="columns[4].visible"
            >
            </el-table-column>
            <el-table-column
              prop="RegisterName"
              label="申请人"
              v-if="columns[5].visible"
            >
            </el-table-column>
            <el-table-column
              prop="IsWellKnown"
              label="是否驰名商标"
              v-if="columns[6].visible"
            >
            </el-table-column>
            <el-table-column
              prop="address"
              label="操作"
              v-if="columns[7].visible"
            >
              <template slot-scope="scope">
                <span
                  class="bluecolor cursorpointer"
                  @click="todetails(scope.row)"
                  >详情</span
                >
                <span
                  class="f14 cursorpointer bluecolor margin-left10"
                  @click="todialog(scope.row)"
                >
                  <span @click="centerDialogVisible = true">增值服务</span>
                </span>
                <span
                  class="f14 cursorpointer bluecolor margin-left10"
                  @click="Submitfromnull(scope.row)"
                >
                  <span>取消托管</span>
                </span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div
            class="flex-betweennowrap pad-top20 pad-right10"
            v-if="total != 0"
          >
            <span class="bluecolor"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="parseInt(per_page)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>

    <el-dialog
      title=""
      :visible.sync="centerDialogVisible"
      :close-on-click-modal="false"
      :show-close="true"
      width="30%"
      center
    >
      <div class="textalign-left pad-bot10 f16">增值服务</div>
      <el-form class="demo-ruleForm">
        <span class="bluecolor lineheight60">{{ companytitle }}</span>
        <el-form-item>
          <p>增值服务</p>
          <el-checkbox
            label="年费提醒"
            v-model="Remind"
            :true-label="1"
            :false-label="0"
          ></el-checkbox>
          <el-checkbox
            label="年费代缴"
            v-model="behalf"
            :true-label="1"
            :false-label="0"
          ></el-checkbox>
          <el-checkbox
            label="委托出售"
            v-model="sell"
            :true-label="1"
            :false-label="0"
          ></el-checkbox>
        </el-form-item>
        <el-form-item>
          <p>提醒日期</p>
          <el-date-picker
            v-model="warnDate"
            type="date"
            placeholder="请选择提醒日期"
            value-format="yyyy-MM-dd"
            :editable="false"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <div class="textalign-right margin-top20">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="Submitfrom()">提 交</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="open" append-to-body width="40%">
      <el-transfer
        :titles="['全选', '全选']"
        v-model="value"
        :data="columns"
        @change="dataChange"
      ></el-transfer>
    </el-dialog>
  </div>
</template>
<script>
import {
  trademarktrusteeshipindex,
  trademarktrusteeshipupdate,
  trademarktrusteeshipremove,
  trademarktrusteeshipsynctrademark,
} from "@/api/patent/patent.api";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      loading: true,
      errormessage: "",
      dialogVisiblenull: false,
      serchkey: true,
      thisNum: 1,
      pages: [],
      total: 0,
      per_page: 0,
      currentPage: 0,
      companytitle: "",
      pagination: false,
      centerDialogVisible: false,
      Remind: 0,
      behalf: 0,
      sell: 0,
      date: "",
      warnDate: "",
      allpage: [],
      ruleForm: {
        number: "",
        crux: "",
      },
      // 显隐数据
      value: [],
      // 弹出层标题
      title: "显示/隐藏",
      // 是否显示弹出层
      open: false,
      columns: [
        { key: 0, label: `商标名称`, visible: true },
        { key: 1, label: `国际分类`, visible: true },
        { key: 2, label: `商标号码`, visible: true },
        { key: 3, label: `申请日期`, visible: true },
        { key: 4, label: `到期日期`, visible: true },
        { key: 5, label: `申请人`, visible: true },
        { key: 6, label: `是否驰名商标`, visible: true },
        { key: 7, label: `操作`, visible: true },
      ],
    };
  },
  components: {
    callback,
    switchcore,
  },
  inject: ["reload"],
  methods: {
    // 右侧列表元素变化
    dataChange(data) {
      for (let item in this.columns) {
        const key = this.columns[item].key;
        this.columns[item].visible = !data.includes(key);
      }
    },
    // 打开显隐列dialog
    showColumn() {
      this.open = true;
    },
    // 清空input
    resetForm() {
      this.ruleForm.number = "";
      this.ruleForm.crux = "";
      this.thisNum = 1;
      trademarktrusteeshipindex({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.IsWellKnown == "") {
              i.IsWellKnown = "否";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 关键词检索
    submitForm() {
      trademarktrusteeshipindex({
        RegNumber: this.ruleForm.number,
        _keywords: this.ruleForm.crux,
        page: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.IsWellKnown == "") {
              i.IsWellKnown = "否";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    // 增值服务
    todialog(row) {
      this.allpage = row;
    },
    Submitfrom() {
      trademarktrusteeshipupdate({
        id: this.allpage.id,
        DataType: 1,
        warn: this.Remind,
        warnDate: this.warnDate,
        patentfee: this.behalf,
        sell: this.sell,
      }).then((res) => {
        if (res.data.code == 200) {
          this.centerDialogVisible = false;
          this.$message({
            showClose: true,
            message: "提交成功",
            type: "success",
          });
          this.refresh();
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 取消托管
    Submitfromnull(row) {
      this.$confirm("此操作将取消托管, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          trademarktrusteeshipremove({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                showClose: true,
                message: "取消成功",
                type: "success",
              });
              this.refresh();
            } else {
              this.drawer = false;
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 同步商标
    patenttrusteeship() {
      trademarktrusteeshipsynctrademark().then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "已同步",
            type: "success",
          });
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    todetails(row) {
      window.sessionStorage.setItem("teadmana", row.id);
      this.$router.push({ path: "/intellectual-property/Tradmanage-details" });
    },
    // 分页
    currentchange(val) {
      this.thisNum = val;
      trademarktrusteeshipindex({
        page: val,
        RegNumber: this.ruleForm.number,
        _keywords: this.ruleForm.crux,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.IsWellKnown == "") {
              i.IsWellKnown = "否";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      trademarktrusteeshipindex({
        page: 1,
        limit: val,
        RegNumber: this.ruleForm.number,
        _keywords: this.ruleForm.crux,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.IsWellKnown == "") {
              i.IsWellKnown = "否";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      trademarktrusteeshipindex({
        page: this.thisNum,
        RegNumber: this.ruleForm.number,
        _keywords: this.ruleForm.crux,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.IsWellKnown == "") {
              i.IsWellKnown = "否";
            }
          });
          this.$loading.hide(); // 隐藏loading
          this.drawer = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    this.companytitle = window.sessionStorage.getItem("companytitle");

    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    this.$loading.show(); // 显示loading
    trademarktrusteeshipindex({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.$loading.hide(); // 隐藏loading
        this.pages = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
        this.pages.forEach((i) => {
          if (i.IsWellKnown == "") {
            i.IsWellKnown = "否";
          }
        });
      } else {
        this.$loading.hide(); // 隐藏loading
        this.drawer = false;
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
.hovercont:hover {
  background: #f7f9fc;
}
.Submit {
  background: #4095e5;
  color: #f9f9f9;
  padding: 5px 20px 5px 20px;
  border-radius: 3px;
}
.Submits {
  background: #e55940;
  color: #f9f9f9;
  padding: 5px 20px 5px 20px;
  border-radius: 3px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>